import type { ThemeVariables } from './AbstractTheme';

export const themeVariables: ThemeVariables = {
  borderRadius: {
    full: {
      desktop: '--theme-border-radius-full-desktop',
      mobile: '--theme-border-radius-full-mobile',
    },
    md: {
      desktop: '--theme-border-radius-md-desktop',
      mobile: '--theme-border-radius-md-mobile',
    },
  },
  colors: {
    content: {
      action: '--theme-color-content-action',
      brand: '--theme-color-content-brand',
      default: '--theme-color-content-default',
      link: '--theme-color-content-link',
      negative: '--theme-color-content-negative',
      positive: '--theme-color-content-positive',
      primary: '--theme-color-content-primary',
      secondary: '--theme-color-content-secondary',
      selected: '--theme-color-content-selected',
      tertiary: '--theme-color-content-tertiary',
    },
    stroke: {
      action: '--theme-color-stroke-action',
      brand: '--theme-color-stroke-brand',
      default: '--theme-color-stroke-default',
      negative: '--theme-color-stroke-negative',
      positive: '--theme-color-stroke-positive',
      selected: '--theme-color-stroke-selected',
    },
    surface: {
      action: '--theme-color-surface-action',
      brand: '--theme-color-surface-brand',
      default: '--theme-color-surface-default',
      negative: '--theme-color-surface-negative',
      positive: '--theme-color-surface-positive',
      selected: '--theme-color-surface-selected',
    },
  },
  tint: {
    disabled: '--theme-tint-disabled',
    hover: '--theme-tint-hover',
  },
  spacing: {
    lg: '--theme-spacing-lg',
    md: '--theme-spacing-md',
    sm: '--theme-spacing-sm',
    xl: '--theme-spacing-xl',
    xs: '--theme-spacing-xs',
    xxl: '--theme-spacing-xxl',
    xxs: '--theme-spacing-xxs',
    xxxl: '--theme-spacing-xxxl',
  },
  strokeWidth: '--theme-stroke-width',
  typography: {
    body: {
      fontFamily: '--theme-typography-body-font-family',
      fontWeight: '--theme-typography-body-font-weight',
      letterSpacing: '--theme-typography-body-letter-spacing',
      sizes: {
        sm: {
          fontSize: '--theme-type-scale-body-sm-font-size',
          lineHeight: '--theme-type-scale-body-sm-line-height',
        },
        md: {
          fontSize: '--theme-type-scale-body-md-font-size',
          lineHeight: '--theme-type-scale-body-md-line-height',
        },
        lg: {
          fontSize: '--theme-type-scale-body-lg-font-size',
          lineHeight: '--theme-type-scale-body-lg-line-height',
        },
      },
    },
    heading: {
      fontFamily: '--theme-typography-heading-font-family',
      fontWeight: '--theme-typography-heading-font-weight',
      letterSpacing: '--theme-typography-heading-letter-spacing',
      sizes: {
        xs: {
          fontSize: '--theme-type-scale-heading-xs-font-size',
          lineHeight: '--theme-type-scale-heading-xs-line-height',
        },
        sm: {
          fontSize: '--theme-type-scale-heading-sm-font-size',
          lineHeight: '--theme-type-scale-heading-sm-line-height',
        },
        md: {
          fontSize: '--theme-type-scale-heading-md-font-size',
          lineHeight: '--theme-type-scale-heading-md-line-height',
        },
        lg: {
          fontSize: '--theme-type-scale-heading-lg-font-size',
          lineHeight: '--theme-type-scale-heading-lg-line-height',
        },
        xl: {
          fontSize: '--theme-type-scale-heading-xl-font-size',
          lineHeight: '--theme-type-scale-heading-xl-line-height',
        },
        xxl: {
          fontSize: '--theme-type-scale-heading-xxl-font-size',
          lineHeight: '--theme-type-scale-heading-xxl-line-height',
        },
      },
    },
  },
};
